import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const token = sp.get("token");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset", { token, password });
      toast.success("Password reset. Please sign in."); nav("/login");
    } catch (err) { toast.error(err?.response?.data?.detail || "Invalid or expired link"); }
  };
  return (
    <div className="blz-container py-14 max-w-md">
      <h1 className="font-display text-3xl font-bold">Reset password</h1>
      <form onSubmit={submit} className="card-flat p-6 mt-6 space-y-3">
        <input type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full h-11 rounded-lg border border-slate-200 px-3" data-testid="reset-password"/>
        <button className="btn-primary w-full" data-testid="reset-submit">Save</button>
      </form>
    </div>
  );
}
